import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4e5fbaa0&scoped=true"
var script = {}
import style0 from "./index.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./index.vue?vue&type=style&index=1&id=4e5fbaa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5fbaa0",
  null
  
)

export default component.exports